/**
 * The five Dutch strings the bridge puts on the wire. RETIRE-WITH-PRICECALCULATOR.
 *
 * Not going through the guest app's i18n, deliberately. The old calculator had no
 * language switch and the site it serves is Dutch-only, so a catalogue here would
 * be one entry per string in one language — and getting at the real catalogue
 * would mean either a locale on `ResultsView` (a change to a permanent seam for
 * the sake of a throwaway one) or importing the guest app's i18n context into a
 * renderer that has no provider around it.
 *
 * `pending` is the exact string the old `widget.js` writes into every marker span
 * itself, on purpose: while a price is in flight the tile should look untouched
 * rather than flickering through a phrasing of ours.
 */
export const DUTCH_LABELS = {
  pending: 'De prijs is nog niet berekend',
  noPrice: 'Prijs op aanvraag',
  unavailable: 'Niet beschikbaar',
  unknown: 'Prijs op aanvraag',
  // Said in the FRAME, because when every tile is hidden the host page has
  // nothing left to say it on.
  nothingFree: 'Er is niets vrij op deze data. Een korter verblijf of een andere week meestal wel.',
} as const;
